export const ACCOUNT_TYPE_OPTIONS = [
  { label: 'message.contact.enterprise', value: 'C' },
  { label: 'message.contact.individual', value: 'P' },
];

export const AMAZON_SITE_URL_MAP = {
  US: 'http://www.amazon.com/s?merchant=', // 美国
  MX: 'http://www.amazon.com.mx/s?merchant=', // 墨西哥
  CA: 'http://www.amazon.ca/s?merchant=', // 加拿大
  UK: 'http://www.amazon.co.uk/s?merchant=', // 英国
  DE: 'http://www.amazon.de/s?merchant=', // 德国
  IT: 'http://www.amazon.it/s?merchant=', // 意大利
  FR: 'http://www.amazon.fr/s?merchant=', // 发过
  ES: 'http://www.amazon.es/s?merchant=', // 西班牙
  NL: 'http://www.amazon.nl/s?merchant=', // 新西兰
  JP: 'http://www.amazon.co.jp/s?merchant=', // 日本
};
